import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IRefDiagnosisRelatedGroup } from './refDiagnosisRelatedGroup'
import { ODataService } from 'common-services'
export interface IBundleDefinition extends IModelBase {
  Name: string
  EpisodeTypeName: string
  SystemEpisodeTypeId: number
  AccountingEpisodeTypeName: string
  AtRisk: boolean
  Description: string
  RefDiagnosisRelatedGroupId: number
  RefDiagnosisRelatedGroup: IRefDiagnosisRelatedGroup
}

@Injectable()
export class BundleDefinitionODataService extends ODataService<IBundleDefinition> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'BundleDefinitions'
  }
}
